import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import LoginForm from '../LoginForm/LoginForm';
import './LoginModal.css';

interface LoginModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  message?: string;
  onLoginSuccess?: () => void;
}

const LoginModal: React.FC<LoginModalProps> = ({
  isOpen,
  onClose,
  title = 'Login Required',
  message = 'Please login to continue.',
  onLoginSuccess
}) => {
  const [formStep, setFormStep] = useState(1);

  useEffect(() => {
    if (!isOpen) {
      setFormStep(1);
    }
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      document.body.classList.add('login-modal-open');
    } else {
      document.body.style.overflow = '';
      document.body.classList.remove('login-modal-open');
    }
    return () => {
      document.body.style.overflow = '';
      document.body.classList.remove('login-modal-open');
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleLoginSuccess = () => {
    if (onLoginSuccess) {
      onLoginSuccess();
    }
    onClose();
  };

  return createPortal(
    <div className="login-modal-overlay" onClick={onClose} role="presentation">
      <div
        className="login-modal-content"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="login-modal-title"
      >
        <div className="login-modal-handle" aria-hidden="true" />
        <div className="login-modal-header">
          <div className="login-modal-header-text">
            <span className="login-modal-icon" aria-hidden="true">
              <i className="fa fa-lock"></i>
            </span>
            <h3 id="login-modal-title">{title}</h3>
          </div>
          <button className="close-btn" onClick={onClose} aria-label="Close">
            <i className="fa fa-times"></i>
          </button>
        </div>
        <div className="login-modal-body">
          {message && formStep === 1 && (
            <p className="login-modal-message">{message}</p>
          )}
          <LoginForm
            onLoginSuccess={handleLoginSuccess}
            compact={true}
            onStepChange={setFormStep}
          />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default LoginModal;
